import { AxiosInterceptor } from "api/core/consts";

export const marketApi = {
  createMarket: (typeId, body) =>
    AxiosInterceptor.post('accountToApi/' + typeId, body),
  createMarketContract: (body) => AxiosInterceptor.post('contractToApi', body),
};
